import type { ContentLang } from '@/features/editor/editorSlice'
import type { NewBlockPreview } from '@/features/editor/lib/newBlockPreview'
import { PhoneCanvas } from './previews/PhoneCanvas'
import { renderBlockPreview } from './previews/renderBlockPreview'
import { CanvasVideoDrop } from './previews/canvasVideoDrop'
import { LessonProgressContext } from './previews/lessonProgress'
import { LiveQuizMascot } from './previews/quizMascotContext'

/**
 * Новый блок, проявляющийся поверх примера, пока телефон едет в центр. Обёрнут
 * теми же контекстами, что телефон холста (`MobilePreviewFrame`), включая живого
 * маскота квиза (`LiveQuizMascot`), — иначе
 * пустой блок выглядел бы иначе (иконка вместо зоны загрузки) и на подмене
 * мелькнул бы. Полоса прогресса — по месту нового блока в уроке; он встаёт в
 * конец, поэтому она полная, как и у примеров в окне (`FULL_PROGRESS`).
 */
export const IncomingBlockPreview = ({
  preview,
  contentLang,
}: {
  preview: NewBlockPreview
  contentLang: ContentLang
}) => {
  return (
    <div className="pointer-events-none absolute inset-0 duration-500 animate-in fade-in">
      <CanvasVideoDrop enabled>
        <LiveQuizMascot>
          <PhoneCanvas className="rounded-2xl">
            <LessonProgressContext.Provider
              value={{ total: preview.total, current: preview.current }}
            >
              {renderBlockPreview(preview.block, contentLang, { onDesignChange: () => {} })}
            </LessonProgressContext.Provider>
          </PhoneCanvas>
        </LiveQuizMascot>
      </CanvasVideoDrop>
    </div>
  )
}
